// "Add to calendar" helpers for the public page: a downloadable .ics file (works
// with Apple/Outlook/most calendar apps) plus a direct Google Calendar link.
function toIcsDate(date) {
  return date.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
}

function escapeIcs(text) {
  return String(text || "").replace(/([,;])/g, "\\$1").replace(/\n/g, "\\n");
}

export function buildIcsFile(wedding) {
  const start = new Date(wedding.data_evento);
  const end = new Date(start.getTime() + 6 * 3600_000); // assume a ~6h celebration
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//WeddingApp//IT",
    "BEGIN:VEVENT",
    `UID:${wedding.slug}@wedding-app`,
    `DTSTAMP:${toIcsDate(new Date())}`,
    `DTSTART:${toIcsDate(start)}`,
    `DTEND:${toIcsDate(end)}`,
    `SUMMARY:${escapeIcs(`Matrimonio di ${wedding.nome_sposi}`)}`,
    wedding.location ? `LOCATION:${escapeIcs(wedding.location)}` : null,
    `DESCRIPTION:${escapeIcs(`Ci sposiamo! ${window.location.href}`)}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].filter(Boolean);
  return new Blob([lines.join("\r\n")], { type: "text/calendar;charset=utf-8" });
}

export function downloadIcs(wedding) {
  const blob = buildIcsFile(wedding);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `matrimonio-${wedding.slug}.ics`;
  a.click();
  URL.revokeObjectURL(url);
}

export function googleCalendarUrl(wedding) {
  const start = new Date(wedding.data_evento);
  const end = new Date(start.getTime() + 6 * 3600_000);
  const fmt = (d) => toIcsDate(d);
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: `Matrimonio di ${wedding.nome_sposi}`,
    dates: `${fmt(start)}/${fmt(end)}`,
    details: `Ci sposiamo! ${window.location.href}`,
    location: wedding.location || "",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
